import React from 'react';
import {LayoutGroup, MotionConfig} from 'framer-motion';
import {ROOT_NAVIGATE_SINGLE_VOYAGES} from "@containers/singleVoyage/navigate/rootNavigate/constants";

import Stack from '@mui/material/Stack';
import ItemNavigateSingleVoyage
    from "@containers/singleVoyage/navigate/rootNavigate/itemNavigate/ItemNavigateSingleVoyage";
import {sx} from './sx'

const RootNavigateSingleVoyage = () => {

    const list = ROOT_NAVIGATE_SINGLE_VOYAGES.map((navigate) => {
        return (
            <ItemNavigateSingleVoyage
                key={navigate.path}
                navigate={navigate}
            />
        )
    })
    return (
        <MotionConfig reducedMotion={'user'}>
            <LayoutGroup id={'sv-root-nav'}>
                <Stack
                    gap={'2px'}
                    direction={'row'}
                    sx={sx.root}
                >
                    {list}
                </Stack>
            </LayoutGroup>
        </MotionConfig>
    );
};

export default RootNavigateSingleVoyage;
